/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERCHandlerHelpers,
  ERCHandlerHelpersInterface,
} from "../ERCHandlerHelpers";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "ContractAddressNotWhitelisted",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToTokenContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_tokenContractAddressToTokenProperties",
    outputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isWhitelisted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "isSet",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "externalDecimals",
            type: "uint8",
          },
        ],
        internalType: "struct ERCHandlerHelpers.Decimals",
        name: "decimals",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultDecimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "setBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERCHandlerHelpersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERCHandlerHelpersConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERCHandlerHelpers__factory extends ContractFactory {
  constructor(...args: ERCHandlerHelpersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERCHandlerHelpers";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERCHandlerHelpers> {
    return super.deploy(
      bridgeAddress,
      overrides || {}
    ) as Promise<ERCHandlerHelpers>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): ERCHandlerHelpers {
    return super.attach(address) as ERCHandlerHelpers;
  }
  connect(signer: Signer): ERCHandlerHelpers__factory {
    return super.connect(signer) as ERCHandlerHelpers__factory;
  }
  static readonly contractName: "ERCHandlerHelpers";
  public readonly contractName: "ERCHandlerHelpers";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERCHandlerHelpersInterface {
    return new utils.Interface(_abi) as ERCHandlerHelpersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERCHandlerHelpers {
    return new Contract(address, _abi, signerOrProvider) as ERCHandlerHelpers;
  }
}
